import Masonary from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export default () => {
    const container = document.querySelector('.post-index__items');

    if (!container) {
        return;
    }

    const msnry = new Masonary(container, {
        columnWidth: '.post-index__sizer',
        itemSelector: '.post-index__item',
        percentPosition: true,
    });

    const imgLoad = imagesLoaded(container.querySelectorAll('img'));

    imgLoad.on('progress', function () {
        msnry.layout();
    });

    const handlePagination = () => {
        const appended = container.querySelectorAll('[data-appended]');
        for (const el of appended) {
            el.removeAttribute('data-appended');
            msnry.appended(el);
        }
        msnry.layout();
    };

    document.addEventListener('blog-pagination-complete', handlePagination);
};
